module.exports = "/images/Blau.png?69a0b9598766ef04d690e30b3c80a350";